import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import CustomDropdown from "../../components/custom-dropdown/CustomDropdown";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import styles from "./OptOutReason.module.scss";
import DOMPurify from "dompurify";

interface OptOutReasonProps {
  message: string;
  handleOptOutProceed: () => void;
  reasons: { label: string; value: string }[];
  setOptOutReason: (reason: number | null) => void;
}

const OptOutReason: React.FC<OptOutReasonProps> = ({
  message,
  handleOptOutProceed,
  reasons,
  setOptOutReason,
}) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const isMobile = useMediaQuery("(max-width: 900px)");
  const sanitizedContent = DOMPurify.sanitize(message);
  const handleReasonChange = (value: string) => {
    setReason(value);
    setOptOutReason(Number(value)); // Update the parent component with the selected reason
  };

  return (
    <Box mt={3}>
      <Box className={styles.optOutContianter}>
        <Box
          sx={{ mb: 2 }}
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <CustomDropdown
              placeholder={t("select")}
              inputFormTitle={t("reasonForOptOut")}
              value={reason}
              changeTrigger={(value) => handleReasonChange(value.toString())}
              options={reasons}
              isRequired
            />
          </Grid>
        </Grid>
      </Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center" mt={3}>
        <CustomButton
          variant="contained"
          onClick={handleOptOutProceed}
          text={t("confirm")}
          disabled={!reason}
          fullWidth={isMobile ? true : false}
        />
      </Box>
    </Box>
  );
};

export default OptOutReason;
